// @ts-nocheck
/* eslint-disable */
export const flCalendarSmallIcon = {
    data: `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.66668 0.666672V2.66667M11.3333 0.666672V2.66667M1.33334 5.33334H14.6667M3.33334 8.33334H5.33334M3.33334 11.6667H5.33334M7.00001 8.33334H9.00001M10.6667 8.33334H12.6667M7.00001 11.6667H9.00001M1.33334 2.66667H14.6667V14.6667H1.33334V2.66667Z" stroke="currentColor" stroke-width="1.6"/></svg>`,
    name: 'calendar-small' as const
};